import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderDefaultDataState } from './order-default-data.reducer';

export const selectOrderDefaultDataState = createFeatureSelector<OrderDefaultDataState>('orderDefaultData');

export const selectOrderDefaultDataResponse = createSelector(selectOrderDefaultDataState, (state) => state.response);

export const selectOrderDefaultDataLoading = createSelector(selectOrderDefaultDataState, (state) => state.loading);

export const selectOrderDefaultDataError = createSelector(selectOrderDefaultDataState, (state) => state.error);

export const selectOrderDefaultDataByKey = (key: string) =>
  createSelector(selectOrderDefaultDataState, (state) => (state.cache || {})[key] ?? null);

export const selectOrderDefaultDataHasDataByKey = (key: string) =>
  createSelector(selectOrderDefaultDataState, (state) => !!(state.cache || {})[key]);

export const selectOrderDefaultDataClonedByKey = (key: string) =>
  createSelector(selectOrderDefaultDataByKey(key), (items) =>
    Array.isArray(items) ? items.map((i) => ({ ...i })) : items ? { ...items } : items,
  );
